import React, { useState } from 'react';
import { Page } from 'components';
import { NotificationForm } from './components';
import ModalAlert from 'components/ModalAlert';
import NotifyModal from 'components/NotifyModal';
import Header from '../../components/Header/Header';

const Notifications = (props) => {

  const [type, setType] = useState({ "color": "", "status": "" });
  const [modalShow, setModalShow] = useState(false);
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [message, setMessage] = useState("");

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.notifications?.read !== true) {
    window.location.replace('/home');
  }

  const handleModalAlert = (msg) => {
    setMessage(msg);
    setShowModalAlert(true)
  }

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  // Controle de tema
  const [currentTheme, setCurrentTheme] = React.useState(
    document.body?.classList.contains('dark-theme') ? 'dark' : 'light'
  );

  React.useEffect(() => {
    const handleThemeChange = () => {
      setCurrentTheme(document.body.classList.contains('dark-theme') ? 'dark' : 'light');
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleThemeChange();
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    return () => observer.disconnect();
  }, []);

  return (
    <Page className={`p-3 ${currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}`} title="Notificações">
      <Header page={'Notificações'} />

      <ModalAlert
        message={message}
        showModalAlert={showModalAlert}
        onHide={() => setShowModalAlert(false)}
      />

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <NotificationForm
        handleModalAlert={handleModalAlert}
        handleAlertModalSuccess={handleAlertModalSuccess}
        handleAlertModalError={handleAlertModalError}
        currentTheme={currentTheme}
      />

    </Page>
  );
};

export default Notifications;
